import { Icon } from '@chakra-ui/react';

const PCMediaCarouselIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 48.37 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>
		<g>
			<g>
				<path class="st0" d="M37.86,6.32c-0.64-2.45-2.61-4.19-5.14-4.54c-0.04-0.01-0.08-0.03-0.11-0.05H17.45
			c-0.47,0.12-0.96,0.19-1.41,0.36c-2.27,0.88-3.61,2.54-3.98,4.96c-0.04,0.27-0.05,0.54-0.05,0.81c0,4.58,0,9.17,0,13.75
			c0,3.07,2.11,5.57,5.14,6.08c0.27,0.05,0.56,0.06,0.83,0.06c4.06,0,7.12,0.01,11.18,0c0.64-0.28,0.82-1.31-0.05-1.6
			c-4,0-6.97-0.14-10.97-0.14c-2.19,0-3.95-1.49-4.34-3.64c-0.05-0.27-0.06-0.54-0.06-0.81c0-4.55,0-9.1,0-13.65
			c0-2.22,1.41-3.94,3.59-4.38c0.3-0.06,0.61-0.08,0.91-0.08c4.55,0,9.1,0,13.65,0.01c2.22,0,4,1.51,4.36,3.7
			c0.05,0.27,0.05,0.56,0.05,0.84c0,2.25,0,4.49,0,6.74c0,2.27,0,4.54,0,6.81c0,1.52-0.6,2.76-1.84,3.66
			c-0.76,0.55-1.62,0.8-2.55,0.8c-0.02,0-0.04,0-0.06,0c-0.7,0.51-0.73,1.41,0.01,1.74c0.06,0,0.13,0,0.19,0
			c2.99-0.01,5.57-2.33,5.93-5.3c0.01-0.05,0.03-0.09,0.05-0.14V7.18C37.98,6.9,37.93,6.61,37.86,6.32z"/>
				<g>
					<path class="st0" d="M28.53,6.39c-1.43,0-2.6,1.18-2.6,2.6c0,1.44,1.16,2.61,2.58,2.62c1.46,0,2.64-1.17,2.63-2.62
				C31.14,7.57,29.95,6.39,28.53,6.39z M28.54,10.68c-0.92,0-1.67-0.75-1.67-1.67c0-0.92,0.75-1.67,1.67-1.67
				c0.92,0,1.67,0.75,1.67,1.67C30.21,9.93,29.46,10.68,28.54,10.68z"/>
					<g>
						<path class="st0" d="M28.46,16.34c-0.68,0.01-0.66,0.01-0.84-0.69c-0.32-1.23-1.1-2-2.29-2.23c-1.22-0.24-2.25,0.19-2.95,1.28
					c-0.26,0.41-0.48,0.54-0.96,0.43c-1.19-0.26-2.39,0.6-2.68,1.83c-0.01,0.06-0.02,0.12-0.03,0.18c-0.05,0.2-0.09,0.47-0.36,0.4
					c-0.24-0.06-0.17-0.32-0.15-0.5c0.17-1.49,1.67-2.66,3.2-2.47c0.28,0.04,0.44-0.04,0.61-0.27c0.85-1.16,1.99-1.66,3.36-1.44
					c1.36,0.23,2.26,1.11,2.71,2.46c0.11,0.33,0.24,0.48,0.59,0.48c1.66,0.03,3.02,1.37,3.19,3.11c0.17,1.7-0.89,3.33-2.46,3.76
					c-0.22,0.06-0.45,0.11-0.67,0.14c-0.19,0.03-0.41,0.02-0.45-0.22c-0.04-0.27,0.19-0.28,0.38-0.31c0.82-0.13,1.55-0.42,2.07-1.14
					c0.71-0.97,0.84-2.03,0.33-3.13C30.54,16.9,29.63,16.38,28.46,16.34z"/>
						<path class="st0" d="M28.6,23.12c-0.5,0-0.59-0.36-0.61-0.49c-0.03-0.2,0.03-0.34,0.09-0.41c0.13-0.18,0.35-0.21,0.5-0.23
					l0.04-0.01c0.88-0.14,1.46-0.45,1.88-1.02c0.66-0.9,0.76-1.85,0.3-2.83c-0.45-0.96-1.23-1.46-2.32-1.5
					c-0.78,0.01-0.91-0.08-1.11-0.85l-0.02-0.06c-0.3-1.13-0.99-1.81-2.06-2.02c-1.11-0.22-2.02,0.18-2.64,1.15
					c-0.29,0.46-0.61,0.71-1.28,0.56c-1-0.22-2.07,0.51-2.33,1.61c-0.01,0.02-0.01,0.04-0.01,0.06c-0.01,0.04-0.01,0.08-0.02,0.11
					l-0.01,0.04c-0.04,0.17-0.09,0.4-0.29,0.52c-0.08,0.05-0.22,0.1-0.42,0.05c-0.47-0.12-0.41-0.6-0.38-0.76
					c0-0.02,0.01-0.04,0.01-0.06c0.09-0.78,0.52-1.53,1.18-2.05c0.68-0.53,1.54-0.78,2.35-0.68c0.17,0.02,0.22,0,0.33-0.15
					c0.92-1.26,2.18-1.8,3.65-1.55c1.43,0.24,2.44,1.16,2.95,2.66c0.09,0.27,0.13,0.28,0.32,0.28c1.8,0.04,3.29,1.49,3.48,3.38
					c0.19,1.85-0.96,3.6-2.68,4.07c-0.23,0.06-0.47,0.11-0.71,0.15C28.71,23.12,28.65,23.12,28.6,23.12z M28.05,16.03
					c0.04,0.01,0.15,0.01,0.26,0.01c-0.16-0.06-0.26-0.15-0.35-0.26C28,15.9,28.03,16,28.05,16.03z M21.62,14.87
					c0.17,0.02,0.27-0.01,0.39-0.15C21.89,14.8,21.77,14.85,21.62,14.87z"/>
					</g>
				</g>
			</g>
			<g>
				<path class="st0" d="M41.19,24.67c-1.47,0-2.75,0-4.03,0v-1.19c1.27,0.02,2.54,0.05,4,0.05C41.77,23.74,41.64,24.47,41.19,24.67z"
				/>
				<path class="st0" d="M47.51,10.01V20.8c-0.01,0.03-0.03,0.07-0.04,0.1c-0.26,2.12-2.1,3.77-4.22,3.77h-0.14
			c-0.53-0.23-0.51-0.88-0.01-1.24h0.04c0.66,0,1.27-0.18,1.81-0.57c0.88-0.64,1.31-1.52,1.31-2.61c0-1.62,0-3.23,0-4.85
			c0-1.6,0-3.2,0-4.8c0-0.2,0-0.4-0.04-0.6c-0.26-1.56-1.52-2.63-3.1-2.63c-1.99,0-3.99,0-5.98,0V6.14h6.49
			c0.03,0.01,0.05,0.03,0.08,0.03c1.8,0.25,3.21,1.48,3.66,3.23C47.43,9.6,47.47,9.81,47.51,10.01z"/>
				<g>
					<path class="st0" d="M40.74,9.45c-1.02,0-1.85,0.84-1.85,1.85c0,1.02,0.83,1.86,1.84,1.86c1.04,0,1.88-0.83,1.88-1.87
				C42.6,10.29,41.75,9.45,40.74,9.45z M40.74,12.5c-0.66,0-1.19-0.53-1.19-1.19c0-0.66,0.53-1.19,1.19-1.19s1.19,0.53,1.19,1.19
				C41.94,11.96,41.4,12.5,40.74,12.5z"/>
					<g>
						<path class="st0" d="M41.36,21.04c-0.16,0.04-0.32,0.08-0.48,0.1c-0.14,0.02-0.29,0.02-0.32-0.16c-0.03-0.19,0.14-0.2,0.27-0.22
					c0.58-0.09,1.1-0.3,1.48-0.81c0.5-0.69,0.6-1.45,0.24-2.23c-0.37-0.79-1.02-1.16-1.85-1.19c-0.48,0.01-0.47,0-0.6-0.49
					c-0.23-0.87-0.78-1.43-1.63-1.59c-0.49-0.09-0.93-0.04-1.31,0.16v-0.42c0.4-0.17,0.84-0.22,1.33-0.14
					c0.97,0.16,1.61,0.79,1.93,1.75c0.08,0.24,0.17,0.34,0.42,0.35c1.18,0.02,2.15,0.98,2.27,2.22
					C43.23,19.58,42.48,20.73,41.36,21.04z"/>
						<path class="st0" d="M43.32,18.35c-0.14-1.35-1.2-2.38-2.48-2.41c-0.13,0-0.16-0.01-0.22-0.2c-0.36-1.07-1.08-1.73-2.1-1.89
					c-0.49-0.08-0.95-0.04-1.37,0.12v0.89c0.36-0.22,0.79-0.29,1.27-0.2c0.76,0.15,1.25,0.63,1.46,1.44l0.01,0.04
					c0.14,0.55,0.23,0.62,0.79,0.61c0.78,0.03,1.34,0.39,1.66,1.07c0.33,0.69,0.25,1.37-0.21,2.01c-0.3,0.41-0.71,0.63-1.34,0.73
					l-0.03,0c-0.1,0.01-0.26,0.04-0.35,0.17c-0.04,0.06-0.08,0.15-0.06,0.29c0.01,0.09,0.08,0.35,0.44,0.35c0.04,0,0.08,0,0.13-0.01
					c0.17-0.02,0.34-0.06,0.5-0.11C42.64,20.91,43.45,19.66,43.32,18.35z M40.34,16.13c0.06,0.08,0.14,0.15,0.25,0.19
					c-0.08,0-0.16,0-0.19-0.01C40.38,16.29,40.36,16.21,40.34,16.13z"/>
					</g>
				</g>
			</g>
			<g>
				<g>
					<g>
						<path class="st0" d="M12.4,4.89c-0.23,0.04-0.45,0.08-0.68,0.12C9.52,5.4,7.31,5.79,5.1,6.18c-1.34,0.24-2.68,0.47-4.01,0.7
					C0.64,6.96,0.52,7.16,0.6,7.6c0.04,0.22,0.09,0.45,0.12,0.67c0.11,0.8,0.3,1.6,0.3,2.4c0.03,4.29,0.01,8.58,0.01,12.88
					c0,0.54,0.13,0.68,0.67,0.68H12.4v-0.91H1.99V13.28H12.4v-0.94c-0.21,0-0.41,0-0.61,0c-0.01,0-0.02,0-0.03-0.01h-1.3l0.02,0.02
					c-0.47,0-0.85,0-1.24,0c-0.02,0-0.03-0.01-0.05-0.01H7.86l0.02,0.02c-0.45,0-0.82,0-1.2,0c-0.02,0-0.04-0.01-0.06-0.02H5.26
					l0.02,0.02c-0.44,0-0.82,0-1.19,0c-0.02,0-0.04-0.01-0.06-0.02H2.01v-1.81H12.4V9.6H7.05c0.38-0.11,0.77-0.18,1.16-0.25
					c1.4-0.25,2.79-0.49,4.19-0.74V7.67c-0.31,0.05-0.6,0.1-0.88,0.15l-1.41,0.25c0,0,0,0,0,0C9.67,8.15,9.3,8.22,8.92,8.28
					c0,0-0.01,0-0.02,0L7.48,8.53L7.41,8.55c-0.37,0.07-0.7,0.13-1.03,0.19c-0.01,0-0.02,0-0.03,0L5.03,8.97c0,0,0,0,0,0
					C4.59,9.05,4.22,9.12,3.85,9.18h0L2.04,9.5L1.9,9.52l-0.41-1.8l10.92-2V4.89z"/>
					</g>
					<path class="st0" d="M12.12,17.86c-0.87-0.58-1.73-1.17-2.62-1.73c-0.14-0.09-0.39-0.12-0.52-0.05c-0.13,0.07-0.23,0.3-0.24,0.46
				c-0.03,0.58-0.01,1.16-0.01,1.74c0,0.59-0.02,1.18,0.01,1.77C8.76,20.21,8.87,20.43,9,20.5c0.12,0.07,0.36,0.04,0.49-0.05
				c0.89-0.57,1.77-1.15,2.64-1.74c0.18-0.12,0.27-0.27,0.27-0.42C12.4,18.14,12.31,17.98,12.12,17.86z M9.67,19.24v-1.91
				c0.48,0.32,0.94,0.62,1.44,0.96C10.61,18.62,10.15,18.92,9.67,19.24z"/>
					<path class="st0" d="M1.8,7.72" />
					<path class="st1" d="M2.01,9.52L2.16,9.5c0.04-0.01,0.07-0.01,0.11-0.02" />
					<path class="st0" d="M6.8,18.29c0,1.8,1.47,3.27,3.27,3.27c0.48,0,0.93-0.1,1.34-0.29c0.78-0.11,0.92,0.58,0.58,0.99
				c-0.58,0.28-1.23,0.44-1.92,0.44c-2.43,0-4.41-1.98-4.41-4.41s1.98-4.41,4.41-4.41c0.85,0,1.65,0.24,2.33,0.67v1.45
				c-0.59-0.6-1.42-0.97-2.33-0.97C8.27,15.01,6.8,16.48,6.8,18.29z"/>
				</g>
				<line class="st1" x1="12.73" y1="11.56" x2="12.73" y2="11.35" />
			</g>
		</g>
	</Icon>
);

export default PCMediaCarouselIcon;
